import type { FaireProductEntity } from "../../entity_types/product";

export const p_9de3mat7p2: FaireProductEntity = {
  token: "p_9de3mat7p2",
  type: "product",
  name: "Zircon Fringe 18K Gold Plated S.Steel Stud Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/529a65255f50aaf6a5776de450993ec62ba7641cc6feb2b0f4c7601007828824.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b537aa1c3b25f3af40012a8540ff68471b789471c2deaa192f348a76bdc202f.jpeg",
    "https://cdn.faire.com/fastly/4ad4e96778d868698e9213f823362d5a466fcebf1d504a945e828882e4707cf3.jpeg",
    "https://cdn.faire.com/fastly/7656056a017f6cedfc2ad8f3e6c7457a81701fb5b49622f6f6627605ddf68832.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "Type: Earrings\nMaterial : Stainless steel，Zircon，18K gold plated\nSize :11mm*30mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 28.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:03.168Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
